module.exports = __webpack_public_path__ + "img/22.add8e6cc.png";